// extracted by mini-css-extract-plugin
module.exports = {"ErrorMessage":"ErrorMessage_ErrorMessage__2cYoX"};